const VERSION = "10.0.10";
export {
  VERSION
};
